import request from '../../../utils/request'

function get(id,type) {

    return request({
        url:    `/data/sponsor_category_full_data`,
        method: 'POST',
        data: {id: id, type: type}
    });

}

function timezones() {

    let timezones = request({
        url:    `/data/get_all_timezones_autocomplete`,
        method: 'POST'
    });

    // console.log("timezones",timezones)

    return timezones;
}

function settings() {
    return request({
        url:    `/data/get_all_timezones_autocomplete`,
        method: 'POST'
    });
}

function create({subject, content}) {
    return request({
        url:    '/message/create',
        method: 'POST',
        data:   {
            subject,
            content
        }
    });
}

const MessageService = {
    get, timezones //, update, delete, etc. ...
}

export default MessageService;
